import JSZip from "jszip";


import FileItem from "../components/FileItem";
import React, { useRef, useState } from 'react';
import HeroSection from "../components/HeroSection";
import { UploadFile, UploadFileWithRef, WorkspaceType, STATES_TYPE, AuthResponse } from "../types/type";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SendMailComponent from "../components/SendMailComponent";
import { funCalculateTotalFileSize } from "../utils/funcCalculateSize";
import { INIT_DATA_AUTH, INIT_WORKSPACE_DATE, MAX_TOTAL_SIZE } from "../utils/constants";

import ValideOTPComponent from "../components/ValideOTPComponent";
import { handleGenerateLink, handleCopyShareLink, handleUploadSingleFile } from "../api";
import FormAuthComponent from "../components/FormAuthComponent";
import FormUploadComponent from "../components/FormUploadComponent";

import iconCopyLink from "../assets/images/icon-copy.png";
import { handleInitWorkspace } from "../utils/handleActions";
import { useTranslation } from "react-i18next";


function Home() {

  const { t, i18n } = useTranslation();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const [stateUI, setStateUI] = useState<STATES_TYPE>({ state: "UPLOAD_STATE" });
  const [isFolder, setIsFolder] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [dataAuth, setDataAuth] = useState<AuthResponse>(INIT_DATA_AUTH);

  const [loadOnly, setLoadOnly] = useState<boolean>(true)

  const [copied, setCopied] = useState<boolean>(false);
  const [byGetLink, setByGetLink] = useState<boolean>(false);
  const [showProgress, setShowProgress] = useState(false);

  const [uploadFiles, setUploadFiles] = useState<UploadFile[]>([]);

  const [workspaceId, setWorkspaceId] = useState<string | "">("");
  const [workspaceData , setWorkspaceData] = useState<WorkspaceType>(INIT_WORKSPACE_DATE);

  const [errors, setErrors] = useState<{ emailValid: boolean }>({ emailValid: false });
  const [formData, setFormData] = useState({ init_email: "" });

  const allDone = uploadFiles.length > 0 && uploadFiles.every(f => f.status === "done");

  // Func handleFileInputClick (Handle File Input Ref)
  const handleFileInputClick = () => {
    fileInputRef.current!.click()
  }

  const handleSendMail = () => setStateUI({state : "MAILING_STATE"});

  const handleRemove = (index: number) => {
    setUploadFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  const changeLanguage = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
  };

    const uploadFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = e.target.files;
      if (!files) return;

      /////////////////////////////////////////////////////////////////
      const currentSize = funCalculateTotalFileSize(uploadFiles, files);
      if (currentSize > MAX_TOTAL_SIZE) {
        toast.error(t("key_error_toast_size_limit"));
        return;
      }
      ///////////////////////////////////////////////////////////////

      let preparedFiles: UploadFileWithRef[] = [];

      if (isFolder) {
        // On compresse le dossier en ZIP AVANT de stocker
        const zip = new JSZip();
        const folderName = files[0]?.webkitRelativePath?.split("/")[0];

        if (!folderName) return;

        for (const file of Array.from(files)) {
          const relativePath = file.webkitRelativePath || file.name;
          zip.file(relativePath, file);
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const zipFile = new File([zipBlob], `${folderName}.zip`, { type: "application/zip" });

        await preparedFiles.push({
          name: zipFile.name,
          size: zipFile.size < 2048 ? `${zipFile.size} Ko` : `${(zipFile.size / 1024 / 1024).toFixed(1)} MB`,
          loading: 0,
          status: "uploading",
          file: zipFile
        });

      } else {
        // Cas simple fichier(s)
        preparedFiles = Array.from(files).map((file) => ({
          name: file.name,
          size: file.size < 2048 ? `${file.size} Ko` : `${(file.size / 1024 / 1024).toFixed(2)} MB`,
          loading: 0,
          status: "uploading",
          file,
        }));
      }


      if (stateUI.state === "SHARE_STATE") {
        if (isFolder) {
          const zip = new JSZip();

          const folderName = files[0]?.webkitRelativePath?.split("/")[0];

          if (!folderName) return;

          for (const file of Array.from(files)) {
            const relativePath = file.webkitRelativePath || file.name;
            zip.file(relativePath, file);
          }

          const zipBlob = await zip.generateAsync({ type: "blob" });
          const zipFile = new File([zipBlob], `${folderName}.zip`, { type: "application/zip" });

          await handleUploadSingleFile(zipFile, workspaceId, dataAuth, setUploadFiles, setShowProgress, t);

        } else {
          // Cas simple fichier
          for (const file of Array.from(files)) {
            await handleUploadSingleFile(file, workspaceId, dataAuth, setUploadFiles, setShowProgress, t);
          }
        }
      }else {
        setUploadFiles((prev) => [...prev, ...preparedFiles]);
      }

      setShowProgress(false);
    };

  return (
    <main className="min-h-screen relative font-gellix flex flex-row max-sm:flex-col md:flex-row gap-20 bg-cover bg-center md:p-20 max-sm:p-10 text-white" style={{ backgroundImage: "url('/images/bg.jpg')" }}>

      <select className="absolute right-4 top-4 bg-transparent outline-none flex gap-2" value={i18n.language} onChange={changeLanguage}>
        <option value="fr" className="text-black">FR</option>
        <option value="en" className="text-black">EN</option>
      </select>

      {/* Section Information */}
      <section className='flex-1 md:sticky top-0 h-[80vh] bg-pink-30 md:w-1/2'>
        <HeroSection />
      </section>

      {/* Section Upload */}
      <section className='flex-1 md:w-1/2 bg-yellow-30'>
        {/* Block ToastConiatner */}
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={true} newestOnTop={false}
          closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />

        {/* Block FormUpload */}
        {(stateUI?.state === "UPLOAD_STATE" ||  stateUI?.state === "SHARE_STATE") && !byGetLink && <FormUploadComponent
          fileInputRef={fileInputRef}
          handleFileInputClick={handleFileInputClick}
          isFolder={isFolder}
          setIsFolder={setIsFolder}
          showProgress={showProgress}
          uploadFile={uploadFile}
        />}

        {/* Block SendMail */}
        {stateUI?.state === "MAILING_STATE" && <SendMailComponent uid={workspaceId} token={dataAuth.access_token} cemail={formData.init_email}/>}

        {/* Block list upload files & folders */}
        {(stateUI?.state === "UPLOAD_STATE" || stateUI?.state === "SHARE_STATE" || stateUI?.state === "MAILING_STATE") && <div className={`lg:px-[10%] md:px-2 flex flex-col gap-10 ${uploadFiles.length > 0 ? "mt-10" : ""}`}>
          <div className="flex flex-col gap-3">
            {uploadFiles.map((file, ind) => (
              <FileItem loadOnly={loadOnly} key={file?.name + file?.file?.lastModified || ind}  file={file} onRemove={() => handleRemove(ind)} />
            ))}
          </div>
        </div>}

        {/* Block Form init authenticate */}
        {stateUI?.state === "UPLOAD_STATE" && <FormAuthComponent email={formData.init_email}
          errors={errors} setErrors={setErrors}
          setFormData={setFormData} uploadFiles={uploadFiles}
          setStateUI={setStateUI} setLoadOnly={setLoadOnly}
        />}

        {/* Block valid OTP */}
        {stateUI?.state === "OTP_STATE" && <ValideOTPComponent 
          email={formData.init_email} 
          uploadFiles={uploadFiles}
          setStateUI={setStateUI} 
          setLoadOnly={setLoadOnly} 
          setDataAuth={setDataAuth} 
          setWorkspaceData={setWorkspaceData}
          setUploadFiles={setUploadFiles}
          setShowProgress={setShowProgress}
          setWorkspaceId={setWorkspaceId}
        />}

        {/* Block buttons */}
        { stateUI?.state === "SHARE_STATE" &&  <div className="lg:px-[10%] md:px-2 mt-10 relative flex flex-col gap-4">
          { !byGetLink && <button
            disabled={uploadFiles.length === 0}
            onClick={() => handleGenerateLink(workspaceId, dataAuth.access_token, workspaceData.share_token, setCopied, setShareLink, setByGetLink, t)}

            className={`w-full flex justify-center outline-none items-center gap-4 rounded-lg p-4 font-bold text-sm transition 
                ${allDone ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
            {t("key_btn_action_get_a_link")}
            {copied && <span className="animate-spin rounded-full h-4 w-4 border-b-4 border-white" />}
          </button>}

          { byGetLink && <div className="flex flex-col gap-3">
            <p className="font-semibold">{t("key_text_link_ready")}</p>
            <div className="bg-white text-black flex gap-2 p-4 rounded-lg">
              <input value={shareLink} className="outline-none w-full pr-2"/>
              <button onClick={() => handleCopyShareLink(shareLink, t)} className="flex cursor-pointer gap-3 mr-2 outline-none">
                <img src={iconCopyLink} alt="Logo copy systalink"/>
                {t("key_btn_action_copy")}
              </button>
            </div>
          </div> }

          { byGetLink && <button
            disabled={uploadFiles.length === 0}
            onClick={() => handleInitWorkspace()}
            className={`w-full flex justify-center outline-none items-center gap-4 rounded-lg p-4 font-bold text-sm transition 
                ${allDone ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
            {t("key_btn_action_send_other_file")}
          </button> }

          { !byGetLink && <button
            disabled={uploadFiles.length === 0}
            onClick={handleSendMail}
            className={`w-full flex justify-center outline-none items-center gap-4 rounded-lg p-4 font-bold text-sm transition 
                ${allDone ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
            {t("key_btn_action_send_by_email")}
          </button>}
        </div>
        }

        

      </section>
    </main>
  );
}

export default Home;
